export const arraysEqual = (arr1: string[], arr2: string[]) => {
  // Check if the arrays have the same length
  if (arr1.length !== arr2.length) return false

  // Check if every element is the same in both arrays
  return arr1.every((element, index) => element === arr2[index])
}
